import React, { Component } from "react";

import { Wrapper } from "app/NativeComponents/common";

import CheckBox from "./CheckBox";

class CheckBoxes extends Component {
  render() {
    return (
      <Wrapper>
        {this.props.list_properties.map((property, i) => {
          return (
            <CheckBox
              toggle_lead_images={this.props.toggle_lead_images}
              last_row={
                i === this.props.list_properties.length - 1 ? true : false
              }
              active_property={this.props.active_property}
              selected_leads={this.props.selected_leads}
              checkLead={this.props.checkLead}
              key={i}
              property={property}
              colors={this.props.colors}
            />
          );
        })}
      </Wrapper>
    );
  }
}

export default CheckBoxes;
